import { environment } from '@environments/environment';

export const getMediaResourceURL = (mediaId: string, thumbnail?: boolean) =>
  `${environment.baseURL}/media/resource/${mediaId}${thumbnail ? '/thumbnail' : ''}`;
